// Digismoothie - DIC field validation

if (theme.request.page_type == "cart" && theme.request.user == "customer") {
  document.addEventListener("DOMContentLoaded", function () {
    function checkDicValue(input) {
      var input = $("#dic").val();
      var firstChar = input.charAt(0);
      console.log(firstChar);
      if (
        firstChar != "" &&
        firstChar.toLowerCase() == firstChar.toUpperCase()
      ) {
        $("#alert").text(
          "Please fill in a valid VAT ID containing country code, e.g. CZ12345678"
        );
      } else {
        $("#alert").text("");
      }
    }

    function blankDicValue(input) {
      var input = $("#dic").val();
      if (input.length == 0) {
        $("#alert").text("");
      }
    }

    checkDicValue();

    $("#dic").keyup(function () {
      checkDicValue();
      blankDicValue();
    });

    $("input#dic").blur(function () {
      checkDicValue();
      blankDicValue();
    });

    // autofill inputs
    const checkCartJS = setInterval(() => {
      clearInterval(checkCartJS);
      if (
        CartJS.cart.attributes["dic"] &&
        $("input.ca-code-dic").val().length == 0
      ) {
        $("input.ca-code-dic").val(CartJS.cart.attributes["dic"]);
      }
      if (
        CartJS.cart.attributes["ico"] &&
        $("input.ca-code-ico").val().length == 0
      ) {
        $("input.ca-code-ico").val(CartJS.cart.attributes["ico"]);
      }
      if (
        CartJS.cart.attributes["firma"] &&
        $("input.ca-code-firma").val().length == 0
      ) {
        $("input.ca-code-firma").val(CartJS.cart.attributes["firma"]);
      }
    }, 100);
  });
}
